import React from 'react'
import {Button, Col, Row, Modal, Container} from 'react-bootstrap'
import {sanitizeHtml} from '../../components/TextEditor'

const ClinicInfoDialog = ({clinicInfo, careUnitName, onCloseClicked}) => {
    return (
    <div className="ClinicInfoDialog">
        <Modal
            show={true}
            onHide={onCloseClicked}
            backdrop="static"
            keyboard={true}
            aria-labelledby="contained-modal-title-vcenter"
            size="lg"
            contentClassName="ClinicInfoDialog-content"
        >
            <Modal.Header closeButton>
                <h3>Information från {careUnitName}</h3>
            </Modal.Header>
            <Modal.Body>
                <Container className={"p-3"}>
                    <Row>
                        <Col>
                            {clinicInfo
                                ? <div dangerouslySetInnerHTML={{__html: sanitizeHtml(clinicInfo)}} />
                                : <p>Ingen klinikinformation tillgänglig för vald mottagare.</p>
                            }
                        </Col>
                    </Row>
                </Container>
                <Button variant={'primary'} className={"ml-1"} onClick={() => {
                    onCloseClicked()
                }}>Stäng</Button>
            </Modal.Body>
        </Modal>
    </div>
    )}
export default ClinicInfoDialog;